import e from "./index899.js";
import a from "./index900.js";
import o from "./index901.js";
import i from "./index902.js";
import n from "./index903.js";
import S from "./index823.js";
import t from "./index904.js";
var g = "[object Map]", j = "[object Object]", f = "[object Promise]", u = "[object Set]", w = "[object WeakMap]", b = "[object DataView]", T = t(e), C = t(a), M = t(o), d = t(i), v = t(n), r = S;
(e && r(new e(new ArrayBuffer(1))) != b || a && r(new a()) != g || o && r(o.resolve()) != f || i && r(new i()) != u || n && r(new n()) != w) && (r = function(m) {
  var c = S(m), p = c == j ? m.constructor : void 0, s = p ? t(p) : "";
  if (s)
    switch (s) {
      case T:
        return b;
      case C:
        return g;
      case M:
        return f;
      case d:
        return u;
      case v:
        return w;
    }
  return c;
});
export {
  r as default
};
